import React from 'react';
import Layout from '../../components/layout';
import IntroductionComponent from '../../components/facilitators/introduction';

const headerText = 'FACILITATORS';

const Facilitators = () => {
  return (
    <Layout headerText={headerText} heroBg="grass">
      <IntroductionComponent />
    </Layout>
  );
};

export default Facilitators;
